// src/components/NotFound.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/App.css'; // Ensure consistent styling

function NotFound() {
  return (
    <div className="text-center page-wrap">
      <h1 className="text-teal mb-4">404 - Page Not Found</h1>
      <p className="text-white mb-4">
        Sorry, the page you're looking for doesn't exist.
      </p>
      <NavLink to="/" className="btn btn-primary">
        Go Home
      </NavLink>
    </div>
  );
}

export default NotFound;
